import { CasConfirmationDialog } from 'src/compass/shared/components';

interface Props {
  onConfirm: VoidFunction;
  // Also what closing the dialog does: the email is left as it was, and the SMS changes are dropped.
  onCancel: VoidFunction;
}

/*
  Asked when the sender leaves SMS mode having changed something there, and the email Body has
  something a replacement would lose. A text has no formatting to give back, so the choice is
  theirs: take the SMS content over whole, or keep the email exactly as it was.
*/
export default function SmsToEmailDialog({ onConfirm, onCancel }: Props) {
  return (
    <CasConfirmationDialog
      open
      title="Copy SMS changes to Email?"
      confirmLabel="Yes"
      cancelLabel="No, drop my SMS editor changes"
      onConfirm={onConfirm}
      onCancel={onCancel}
    >
      You have made changes while in the SMS editor. Do you want the SMS content translated to the
      Email editor (losing formatting and replacing your previous content in the Email editor)?
    </CasConfirmationDialog>
  );
}
